export interface TagPromoOffResult {
  price: number
  compare_at_price: number
  isPromoOff: boolean
  isOnSale: boolean
}

// Tag-promo-off pricing used by the metafield cron (is_promo_off flag). Must
// stay aligned with TagPromoOffProvider's own implementation until Part 2
// refactors the provider to import this helper.
export function computeTagPromoOff(
  config: any,
  tags: string[],
  price: number,
  compare_at_price: number
): TagPromoOffResult {
  const isPremium = tags?.includes('Premium:yes')
  if (isPremium || price < compare_at_price)
    return { price, compare_at_price, isPromoOff: false, isOnSale: true }

  const matched = config?.data?.slices?.find(
    (slice: any) =>
      tags &&
      tags
        .map((tag: string) => tag?.toLowerCase())
        .includes(slice?.primary?.tagName?.toLowerCase())
  )

  const discount = matched?.primary?.discount ?? 0

  if (discount > 0) {
    return {
      price: (price * (100 - discount)) / 100.0,
      compare_at_price: price,
      isPromoOff: true,
      isOnSale: true,
    }
  }

  return { price, compare_at_price, isPromoOff: false, isOnSale: false }
}
